import { ResourcePanelAddToGrid } from "../api/generated/data-contracts";
import { settings } from "../context/network/http/QueryProvider/queries/UISettings"

export const resourceAddToGridEnabled = (type: ResourcePanelAddToGrid) => {
	const addToGrid = settings().resourcePanelAddToGrid;
	if (addToGrid == null) return true;
	return addToGrid.indexOf(type) >= 0;
}
